import { createSelector } from "reselect";
import { initialState } from "./reducer";

/**
 * Direct selector to the treatmentFlow state domain
 */

const selectTreatmentFlowDomain = state =>
  state.get("treatmentFlow", initialState);

/**
 * Other specific selectors
 */
const makeSelectTreatmentFlowConfiguration = () =>
  createSelector(selectTreatmentFlowDomain, substate => {
    const productPlan = substate.get("productPlan");

    if (productPlan && productPlan.productTypeConfiguration) {
      const { products = [] } = productPlan.productTypeConfiguration;
      const { orders = [] } = productPlan;

      if (orders.length === 0) {
        return productPlan.productTypeConfiguration;
      }

      return {
        ...productPlan.productTypeConfiguration,
        products: products.map(product => ({
          ...product,
          ...orders.find(order => order.order === product.order),
        })),
      };
    }

    return {};
  });

const makeSelectTreatmentFlowCurrentConfig = () =>
  createSelector(selectTreatmentFlowDomain, substate =>
    substate.get("currentConfiguration"),
  );

const makeSelectTreatmentFlowProductPlan = () =>
  createSelector(selectTreatmentFlowDomain, substate =>
    substate.get("productPlan"),
  );

const makeSelectTreatmentFlowConfigurations = () =>
  createSelector(selectTreatmentFlowDomain, substate =>
    substate.get("configurations"),
  );

const makeSelectTreatmentFlowTypes = () =>
  createSelector(
    selectTreatmentFlowDomain,
    substate => substate.toJS().types || [],
  );

const makeSelectTreatmentFlowInitialLoading = () =>
  createSelector(selectTreatmentFlowDomain, substate =>
    substate.get("initialLoading"),
  );

/**
 * Default selector used by TreatmentFlow
 */

const makeSelectTreatmentFlow = () =>
  createSelector(selectTreatmentFlowDomain, substate => substate.toJS());

export default makeSelectTreatmentFlow;
export {
  selectTreatmentFlowDomain,
  makeSelectTreatmentFlowConfiguration,
  makeSelectTreatmentFlowTypes,
  makeSelectTreatmentFlowInitialLoading,
  makeSelectTreatmentFlowProductPlan,
  makeSelectTreatmentFlowConfigurations,
  makeSelectTreatmentFlowCurrentConfig,
};
